export default __webpack_public_path__ + "f61e5dcd2a8272d5f6d276793ee06975.svg";